import React from "react";
import { useStaticQuery, graphql, navigate } from "gatsby";
import Img from "gatsby-image";
// import MiscSocialSmall from "./../../components/icons/MiscSocialSmall";
import ArtsFoundationHeroLanding from "./../../components/ArtsFoundationHeroLanding";
import Layout from "./../../components/Layout";
import FoundationRequestInformationForm from "./../FoundationRequestInformationForm";
import {
  FoundationWrapperDiv,
  FoundationWrapperInnerDiv,
  FoundationWrapperWhiteDiv,
} from "./elements";

const FoundationWrapper = ({
  children,
  title,
  selected,
  seoTitle,
  seoDescription,
  selection,
  selectedProgram,
  whiteBackground,
  useStayInformed,
  
}) => {
  const basicQuery = useStaticQuery(graphql`
    {
      craftFoundationFrontFoundationFrontEntry {
        foundationDisableLearnings
        seoTitle
        seoDescription
        foundationHeaderImages {
          ... on Craft_foundationHeaderImages_headerImages_BlockType {
            grantsImage {
              ... on Craft_communityAssets_Asset {
                mobile: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 420, height: 210, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                card: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 690, height: 420, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_editorialAssets_Asset {
                mobile: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 420, height: 210, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                card: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 690, height: 420, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
            projectsImage {
              ... on Craft_communityAssets_Asset {
                mobile: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 420, height: 210, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                card: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 690, height: 420, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_editorialAssets_Asset {
                mobile: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 420, height: 210, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                card: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 690, height: 420, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
            learningImage {
              ... on Craft_communityAssets_Asset {
                mobile: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 420, height: 210, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                card: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 690, height: 420, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_editorialAssets_Asset {
                mobile: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 420, height: 210, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                card: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 690, height: 420, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
            residencyImage {
              ... on Craft_communityAssets_Asset {
                mobile: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 420, height: 210, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                card: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 690, height: 420, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_editorialAssets_Asset {
                mobile: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 420, height: 210, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                card: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 690, height: 420, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
            commonRoomImage {
              ... on Craft_communityAssets_Asset {
                mobile: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 420, height: 210, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                card: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 690, height: 420, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
              ... on Craft_editorialAssets_Asset {
                mobile: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 420, height: 210, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
                card: localFile {
                  publicURL
                  childImageSharp {
                    fixed(width: 690, height: 420, fit: COVER) {
                      src
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `).craftFoundationFrontFoundationFrontEntry;

  const foundationImagesQuery = basicQuery.foundationHeaderImages[0];
   var foundationSeoTitle = basicQuery.seoTitle?basicQuery.seoTitle:null;
  var foundationSeoDescription = basicQuery.seoDescription?basicQuery.seoDescription:null;
 
  // console.log(foundationImagesQuery);
  const images = [
    {
      image: (
        <React.Fragment>
          <Img
            className="desktop"
            fixed={
              foundationImagesQuery.learningImage[0].card.childImageSharp.fixed
            }
          />
          <Img
            className="mobile"
            fixed={
              foundationImagesQuery.learningImage[0].mobile.childImageSharp
                .fixed
            }
          />
        </React.Fragment>
      ),
      link: "/foundation",
      title: "About",
    },
    {
      image: (
        <React.Fragment>
          <Img
            className="desktop"
            fixed={
              foundationImagesQuery.residencyImage[0].card.childImageSharp.fixed
            }
          />
          <Img
            className="mobile"
            fixed={
              foundationImagesQuery.residencyImage[0].mobile.childImageSharp
                .fixed
            }
          />
        </React.Fragment>
      ),
      link: "/foundation/residency-research",
      title: "Residency + Research",
    },
    {
      image: (
        <React.Fragment>
          <Img
            className="desktop"
            fixed={
              foundationImagesQuery.projectsImage[0].card.childImageSharp.fixed
            }
          />
          <Img
            className="mobile"
            fixed={
              foundationImagesQuery.projectsImage[0].mobile.childImageSharp
                .fixed
            }
          />
        </React.Fragment>
      ),
      link: "/foundation/exhibitions-commissions",
      title: "Programmes",
    },
    {
      image: (
        <React.Fragment>
          <Img
            className="desktop"
            fixed={
              foundationImagesQuery.commonRoomImage[0].card.childImageSharp
                .fixed
            }
          />
          <Img
            className="mobile"
            fixed={
              foundationImagesQuery.commonRoomImage[0].mobile.childImageSharp
                .fixed
            }
          />
        </React.Fragment>
      ),
      link: "/foundation/common-room",
      title: "Common Room",
    },
  ];
  if (!basicQuery.foundationDisableLearnings) {
    images.push({
      image: (
        <React.Fragment>
          <Img
            className="desktop"
            fixed={
              foundationImagesQuery.learningImage[0].card.childImageSharp.fixed
            }
          />
          <Img
            className="mobile"
            fixed={
              foundationImagesQuery.learningImage[0].mobile.childImageSharp
                .fixed
            }
          />
        </React.Fragment>
      ),
      link: "/foundation/learning",
      title: "Learning",
    });
  }
  // console.log(basicQuery);

  return (
    <Layout fullWidth backgroundColor={"var(--pink)"} title={foundationSeoTitle} SEODescription={foundationSeoDescription} >
      <FoundationWrapperDiv>
        <FoundationWrapperInnerDiv>
          {/*<MiscSocialSmall color={"var(--black)"} />*/}
          <ArtsFoundationHeroLanding
            title={title}
            selected={selected}
            selection={selection}
            menuItems={images}
            returnLink={(e) => {
              navigate(e);
            }}
          />
          {children}
        </FoundationWrapperInnerDiv>
        {whiteBackground ? (
          <FoundationWrapperWhiteDiv>
            {whiteBackground}
          </FoundationWrapperWhiteDiv>
        ) : null}
        <FoundationRequestInformationForm useStayInformed={true} />
        {selectedProgram}
      </FoundationWrapperDiv>
    </Layout>
  );
};

export default FoundationWrapper;
